import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import ChatWidget from "@/components/ChatWidget";

const NAV = [
  { to: "/", label: "Início" },
  { to: "/produtos", label: "Produtos" },
  { to: "/contato", label: "Contato" },
];

export default function PublicLayout() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  useEffect(() => { document.title = "ATP Confecções"; }, []);
  return (
    <div className="min-h-screen bg-[#07090E] text-slate-100 flex flex-col">
      <header className="sticky top-0 z-40 backdrop-blur-md bg-[#07090E]/80 border-b border-slate-800/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
            <img src="/atp-logo.webp" alt="ATP Confecções" className="h-10 w-auto object-contain" />
          </Link>
          <nav className="hidden md:flex items-center gap-8">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase()}`}
                className={({isActive}) => `text-sm font-medium transition-colors ${isActive ? "text-[#0CDBF2]" : "text-slate-300 hover:text-white"}`}>
                {n.label}
              </NavLink>
            ))}
            <Link to="/orcamento" data-testid="nav-quote">
              <Button className="bg-[#0CDBF2] hover:bg-[#0ABED4] text-[#07090E] font-semibold" data-testid="nav-quote-btn">Solicitar orçamento</Button>
            </Link>
          </nav>
          <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
            {open ? <X /> : <Menu />}
          </button>
        </div>
        {open && (
          <div className="md:hidden border-t border-slate-800 bg-[#0B0F17] px-4 py-4 space-y-3">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className="block text-slate-200" data-testid={`mnav-${n.label.toLowerCase()}`}>{n.label}</Link>
            ))}
            <Link to="/orcamento" onClick={() => setOpen(false)} className="block text-[#0CDBF2] font-semibold" data-testid="mnav-quote">Solicitar orçamento</Link>
          </div>
        )}
      </header>

      <main className="flex-1"><Outlet key={loc.pathname} /></main>
      <ChatWidget />

      <footer className="border-t border-slate-800 bg-[#0B0F17] mt-16">
        <div className="max-w-7xl mx-auto px-6 py-10 grid md:grid-cols-3 gap-8">
          <div className="flex items-center gap-4">
            <img src="/atp-logo.webp" alt="ATP Confecções" className="h-24 sm:h-40 w-auto object-contain shrink-0" />
            <div className="text-sm text-slate-400 space-y-1 leading-relaxed" data-testid="footer-company">
              <div className="text-slate-300 font-medium">ATP Confecções Ltda</div>
              <div>CNPJ: 38.581.693/0001-26</div>
              <div>Rua Valencio Manoel Floriano, 1125 — CEP 95560-000 — Torres/RS</div>
            </div>
          </div>
          <div>
            <div className="font-semibold mb-3">Produtos</div>
            <ul className="text-sm text-slate-400 space-y-1.5">
              <li>Uniformes corporativos</li><li>Uniformes esportivos</li>
              <li>Camisetas & Polos</li><li>Moletons & Jaquetas</li>
            </ul>
          </div>
          <div>
            <div className="font-semibold mb-3">Contato</div>
            <ul className="text-sm text-slate-400 space-y-1.5">
              <li>WhatsApp comercial</li><li>financeiro@atpconfec.com</li>
              <li className="pt-2"><a href="https://wa.me/" className="text-[#0CDBF2] hover:underline" data-testid="footer-whatsapp">Falar no WhatsApp</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-800/60 py-4 text-center text-xs text-slate-500">© {new Date().getFullYear()} ATP Confecções — Todos os direitos reservados.</div>
      </footer>
    </div>
  );
}
